import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonServiceService } from 'src/app/pages/services/common-service.service';
import { MatMenuTrigger } from '@angular/material/menu';


@Component({
  selector: 'app-communication-sidebar',
  templateUrl: './communication-sidebar.component.html',
  styleUrls: ['./communication-sidebar.component.scss']
})
export class CommunicationSidebarComponent implements OnInit, OnChanges {

  constructor(
    private commonService: CommonServiceService, private formbuilder: FormBuilder, public router: Router, private route: ActivatedRoute
  ) {
    this.filterForm = this.formbuilder.group({

    });


   }
  messengerList: any = [];
  messageLineItemDetails: any = [];
  @Output() viewData: EventEmitter<any> = new EventEmitter();
  @Output() setApplyFiltr: EventEmitter<any> = new EventEmitter();
  @Output() tabSwitched: EventEmitter<any> = new EventEmitter();
  @Input() msgHighlighted = false;
  @Input() msgDeleted = false;
  @Input() msgUpdated = false;
  @Input() selectedMatIndex = 0;
  userData: any = JSON.parse(sessionStorage.getItem('userdata') || '{}');
  fromJson: any = [
    { id: '4', name: 'MSME', isChecked: false },
    { id: '6', name: 'Admin', isChecked: false },
  ];

  toJson: any = [
    {
      name : 'MSME',
      id : 'msme',
      isChecked : false
    }
  ];

  statusJson: any = [
    {
      name : 'Replied',
      id : 1,
      isChecked : false
    },
    {
      name : 'Pending',
      id : 2,
      isChecked : false
    },
    {
      name : 'Reminder',
      id : 3,
      isChecked : false
    }
  ];
  filterForm: FormGroup;
  selectedFromID: any;
  selectedMsme = '';
  filterParam: any;
  approveStatus = '';
  rejectStatus = '';
  pendingStatus = '';
  showInfo = false;
  totalCount  = 1;
  allListData: any[] = [];
  appliedFilter = false;
  lineItemID = 0;
  @ViewChild(MatMenuTrigger) matMenuTrigger: MatMenuTrigger | undefined;
  searchedValue = '';
  starMessage = false;
 totalScrollData = 0;
  page = 1;
  count = 0;

  dataVisible = false;

buttonType = 'receive';

  truncate(value: string | null | undefined, len: number): string {
    if (value == null || typeof value !== 'string') { return ''; }
    return value.length > len ? value.substring(0, len) + '...' : value;
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.buttonType = this.buttonType ? this.buttonType : 'receive';
    if (changes && changes.msgHighlighted && changes.msgHighlighted.currentValue){
        this.allListData = [];
        this.starMessage = changes.msgHighlighted.currentValue;
        this.getCommunicationList('', '', '', 1, this.buttonType, true);
    }
    if (changes && changes.msgDeleted && changes.msgDeleted.currentValue){
        this.allListData = [];
        this.getCommunicationList();
    }

    if (changes && changes.msgUpdated && changes.msgUpdated.currentValue){
      this.getCommunicationList(this.lineItemID);
    }

    if (changes && changes.selectedMatIndex && changes.selectedMatIndex.currentValue){
      this.fetchStatus('receive');
    }
  }



  ngOnInit(): void {
    this.commonService.notificationClicked.subscribe((value: any) => {
      if (value){
        this.showData(value);
      }

    });
    this.commonService.isMarkAllRead.subscribe((value: any) => {

      if (value){
        const test = 'isMArkaAllRead' + value;
        this.getCommunicationList('', '', '', 1, 'receive', true);
      }

    });

    let id: any = this.route.snapshot.queryParamMap.get('id');
    id = id ? parseInt(id, 10) : this.lineItemID;
    this.showData(id);
  }

  showData(id: any): void {
    if (id){
      this.lineItemID = parseInt(id, 10);
      this.getCommunicationList();
      setTimeout(() => {
        this.getCommunicationList(this.lineItemID);
      }, 1000);
    }
    else{
      this.getCommunicationList('', '', '', 1, 'receive');
    }
  }

  scrollHandler(event: any): void {
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {

      if (this.totalCount !== this.totalScrollData){
        this.page = this.page + 1;
        this.getCommunicationList('', '', '', this.page);
      }
    }
  }

  showMoreChats(): void {
    this.page = this.page + 1;
    this.getCommunicationList('', '', '', this.page);
  }


  bottomReached(): boolean {
    return (window.innerHeight + window.scrollY) >= document.body.offsetHeight;
  }

  onValueChange(event: any, data: any, type: any): void {
    if (type === 'from'){
      this.selectedFromID = 'from=' + data.id;
    }else if (type !== 'to') {
      if (data.id === 1 && data.isChecked){
        this.approveStatus = 'status=' + data.id;
      }else{
        if (data.id === 1 && !data.isChecked){
          this.approveStatus = '';
        }
      }
      if (data.id === 2 && data.isChecked){
        this.pendingStatus = 'status=' + data.id;
      }else{
        if (data.id === 2 && !data.isChecked){
          this.pendingStatus = '';
        }
      }

      if (data.id === 3 && data.isChecked){
        this.rejectStatus = 'status=' + data.id;
      }else{
        if (data.id === 3 && !data.isChecked){
          this.rejectStatus = '';
        }
      }
    }
  }


  applyFilter(): void {
    let filterParams = '';
    if (this.selectedFromID && this.selectedMsme && this.approveStatus && this.rejectStatus && this.pendingStatus){
      filterParams = this.selectedFromID + '&' + this.selectedMsme + '&' + this.approveStatus +
        '&' + this.rejectStatus + '&' + this.pendingStatus;
    }

    if (this.selectedFromID){
      filterParams = this.selectedFromID;
    }

    if (this.selectedMsme){
      if (filterParams){
        filterParams = filterParams + '&' + this.selectedMsme;
      }else{
        filterParams = this.selectedMsme;
      }
    }

    if (this.approveStatus){
      if (filterParams){
        filterParams = filterParams + '&' + this.approveStatus;
      }else{
        filterParams = this.approveStatus;
      }
    }

    if (this.rejectStatus){
      if (filterParams){
        filterParams = filterParams + '&' + this.rejectStatus;
      }else{
        filterParams = this.rejectStatus;
      }
    }

    if (this.pendingStatus){
      if (filterParams){
        filterParams = filterParams + '&' + this.pendingStatus;
      }else{
        filterParams = this.pendingStatus;
      }
    }

    if (filterParams){
      this.appliedFilter = true;
      this.setApplyFiltr.emit(false);
      this.getCommunicationList('', filterParams);
    }
    if (this.matMenuTrigger) {
      this.matMenuTrigger.closeMenu();
    }
  }

  resetFilters(type: any): void {
    this.buttonType = type;
    this.appliedFilter = false;
    this.messengerList = [];
    this.allListData = [];
    const fromJson = JSON.parse(JSON.stringify(this.fromJson));
    this.fromJson = [];
    this.fromJson  = fromJson;
    this.toJson.forEach((ele: any) => ele.isChecked = false);
    this.statusJson.forEach((ele: any) => ele.isChecked = false);

    this.selectedFromID = '';
    this.selectedMsme = '';
    this.approveStatus = '';
    this.rejectStatus = '';
    this.pendingStatus = '';
    this.setApplyFiltr.emit(false);
    this.getCommunicationList('', '', '', 1 , type);
    if (this.matMenuTrigger) {
      this.matMenuTrigger.closeMenu();
    }

  }


  getCommunicationList(
    id: any = '', searchedValue: any = '', filterParam: any = '', page: number = 1, status: string = '', isMarkAllReadyRead: boolean= false
  ): void {
    this.commonService.communicaionList(
      id, filterParam, page, false, status, this.userData?.id, searchedValue, this.starMessage
    ).subscribe((res: any) => {
      if (res.success){
        if (id){
          this.allListData.map((ele: any) => {
            if (ele.id === this.lineItemID){
              ele.is_Clickable = true;
              ele.is_visible = true;
            }
            return ele;
          });
          this.messageLineItemDetails = res.data;
          const fullName = this.messageLineItemDetails.name;
          const initials = fullName.split(' ').map((name: any) => name[0]).join('').toUpperCase();
          this.messageLineItemDetails.nameInitials = initials;
          const color = Math.floor(0x1000000 * Math.random()).toString(16);

          this.messageLineItemDetails.color = '#' + ('000000' + color).slice(-6);

          this.viewData.emit(this.messageLineItemDetails);

        }else{
          this.totalScrollData += res.data.length;
          this.totalCount = res.total;
          if (res.data?.length){
            res.data = res.data.map((el: any) => {
              if (el?.id === this.lineItemID){
                el.is_Clickable = true;
              }
              else{
                el.is_Clickable = false;
              }
              return el;
            });
          }
          this.messengerList = res?.data;


          if (this.appliedFilter){
            this.allListData = res?.data;
            if (this.allListData.length === 0){
              this.showInfo = true;
            }else{
              this.showInfo = false;
            }
          }else{
            if (this.dataVisible || this.buttonType){
              this.allListData = [];
            }
            if (this.messengerList.length === 0 && this.allListData.length === 0){
              this.showInfo = true;
            }
            else{
              this.showInfo = false;
            }
            this.allListData = [...this.allListData, ...this.messengerList];
            if (isMarkAllReadyRead){
              this.allListData = this.allListData.map((el: any) => {
                el.is_visible =  true;
                return el;
              });
            }
            this.allListData = this.allListData.map((el: any) => {
              if (el.id === this.lineItemID){
                el.is_Clickable = true;
              }
              else{
                el.is_Clickable = false;
              }
              return el;
            });
          }

          for (let i = 0; i <= this.messengerList.length; i++){
            const fullName = this.messengerList[i].name;
            const initials = fullName.split(' ').map((name: any) => name[0]).join('').toUpperCase();
            this.messengerList[i].nameInitials = initials;
            const color = Math.floor(0x1000000 * Math.random()).toString(16);

            this.messengerList[i].color = '#' + ('000000' + color).slice(-6);
          }
        }

      }
    });
  }
  communicationUpdate(data: any): void {
    this.lineItemID = data.id;
    this.dataVisible = data.is_visible;
    this.allListData = this.allListData.map((el: any) => {
      if (el.id === data.id){
        el.is_Clickable = true;
      }
      else{
        el.is_Clickable = false;
      }
      return el;
    });
    if (!data?.is_visible){
        this.dataVisible = true;
    }
    const payload = {
      subject: data?.subject,
      message: data?.message,
      sender_id: data?.sender_id,
      receiver_id: data?.receiver_id || this.userData?.id,
      createdBy: data?.createdBy,
      is_highlight: data?.is_highlight,
      is_visible: this.dataVisible

    };

    this.commonService.communicationUpdate(data.id, payload).subscribe((res: any) => {
      if (res.success){

        this.getCommunicationList(data.id);
        this.commonService.isCommunication.next(true);
      }
    });
  }

  openSelectedMsg(data: any): void {
    this.communicationUpdate(data);
  }
fetchStatus(type: any): void {
  this.buttonType = type;
  this.getCommunicationList('', '', '', 1 , type);
  this.searchedValue = '';
  this.tabSwitched.emit(true);
}


onKeyDownEvent(): void {
  this.getCommunicationList('', this.searchedValue, '', 1 , this.buttonType);
}

clearSearch(): void {
  this.searchedValue = '';
  this.getCommunicationList('', '', '', 1 , this.buttonType);
}
}
